export const ROUTE_GENERATE_DRAFT = '/draft/generate/:entity(book|order)/:id';
export const ROUTE_GENERATE_DRAFT_WELCOME_JOURNEY =
  '/welcome/draft/generate/:entity(book|order)/:id/:flowPath';

export const ROUTE_DRAFT = '/draft/:draftId';
export const ROUTE_DRAFT_VIEW = `${ROUTE_DRAFT}`;
export const ROUTE_DRAFT_CHECKOUT = `${ROUTE_DRAFT}/checkout`;
